import React, { ReactNode, useEffect, useState, useMemo } from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import Keys from "./constants/helper";
import muiThemeOptions from "./theme/muiTheme";
import muiThemeKIDSOptions from "./theme/muiThemeKIDS";

interface IProps {
    children: ReactNode;
}

const Theme: React.FC<IProps> = ({ children }) => {
    const [role, setRole] = useState(localStorage.getItem(Keys.EPIC_USER_ROLE) || "DEFAULT");

    // Listen for storage changes safely
    useEffect(() => {
        const handleStorage = (event: StorageEvent) => {
            if (event.key === Keys.EPIC_USER_ROLE) {
                setRole(event.newValue || "DEFAULT");
            }
        };
        window.addEventListener("storage", handleStorage);
        return () => window.removeEventListener("storage", handleStorage);
    }, []);

    // Create stable theme object
    const theme = useMemo(() => {
        return createTheme(role === "KIDS" ? muiThemeKIDSOptions : muiThemeOptions);
    }, [role]);

    return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default Theme;
